import { ReactNode } from "react";

interface LayoutRelatorioProps {
  children: ReactNode;
}

const LayoutRelatorio: React.FC<LayoutRelatorioProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-background flex flex-col font-ageo-regular">
      <main className="container mx-auto p-6 flex-1">{children}</main>
    </div>
  );
};

export default LayoutRelatorio;